import { supabase } from '@/lib/supabase';
import { detectTrafficSource } from '@/lib/trafficSource';

// ============================================================
// Suivi de visites des pages de thème (sites publics des marchands).
// Chaque page enregistre :
//   • un compteur de vues (event "view") ;
//   • le temps passé (event "leave", en secondes) ;
//   • l'adresse IP réelle du visiteur (captée côté serveur) ;
//   • le comportement : referrer, user-agent, pays, session, chemin.
// L'écriture passe par une Edge Function qui lit l'IP du visiteur dans
// les en-têtes de la requête (indisponible côté navigateur).
// ============================================================

export interface ThemeVisitEvent {
  boutique_id: number | null;
  page_key: string;
  path: string;
  event: 'view' | 'leave' | 'ping';
  duration_seconds?: number;
  referrer?: string;
  source?: string;
}

/** Identifiant de session stable (mémorisé tant que l'onglet est ouvert). */
export function getVisitSessionId(): string {
  try {
    let id = sessionStorage.getItem('zifek_sid');
    if (!id) {
      id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem('zifek_sid', id);
    }
    return id;
  } catch {
    return 'anon';
  }
}

/**
 * Envoie un événement de visite. Best-effort : n'échoue jamais bruyamment.
 */
export async function trackThemePageVisit(payload: ThemeVisitEvent): Promise<void> {
  try {
    await supabase.functions.invoke('theme-visit-track', {
      body: {
        ...payload,
        session_id: getVisitSessionId(),
        referrer: payload.referrer ?? (typeof document !== 'undefined' ? document.referrer : ''),
        source: payload.source ?? detectTrafficSource().source,
      },
    });
  } catch {
    /* best-effort : le suivi ne doit jamais gêner la navigation */
  }
}